// Quote Slider
var quote_thumbs = new Swiper('.quote_thumbs', {
  spaceBetween: 10,
  slidesPerView: 1,
  // centeredSlides: true,
  // centeredSlidesBounds: true,
  // freeMode: false,
  // initialSlide: 2,
  // watchSlidesProgress: true,
  // slideToClickedSlide: true,
  breakpoints: {
    720: {
      slidesPerView: 5,
    },
  },
});

var quote_slider = new Swiper('.quote-slider', {
  thumbs: {
    swiper: quote_thumbs,
  },
  // watchSlidesProgress: true,
  // initialSlide: 2,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    // renderBullet: function (index, className) {
    //   return '<span class="' + className + '">' + (index + 1) + '</span>';
    // },
  },
});

quote_slider.on('slideChange', function () {
  quote_thumbs.slideTo(quote_slider.activeIndex);
});

quote_thumbs.on('slideChange', function () {
  quote_slider.slideTo(quote_thumbs.activeIndex);
});
